import React from 'react';

const ToggleSwitchYes = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="28" viewBox="0 0 44 28" fill="none" { ...rest }>
      <g clipPath="url(#clip0_513_1553)">
        <rect width="44" height="28" rx="14" fill="#FA1861" />
        <g filter="url(#filter0_dd_513_1553)">
          <path fillRule="evenodd" clipRule="evenodd" d="M30 26C36.6274 26 42 20.6274 42 14C42 7.37258 36.6274 2 30 2C23.3726 2 18 7.37258 18 14C18 20.6274 23.3726 26 30 26ZM35.1449 12.2788C35.5198 11.9039 35.5198 11.2961 35.1449 10.9212C34.77 10.5463 34.1621 10.5463 33.7872 10.9212L29.1985 15.5099L27.331 13.5735C26.963 13.1918 26.3552 13.1808 25.9736 13.5489C25.592 13.9169 25.5809 14.5246 25.949 14.9063L28.495 17.5464C28.6739 17.7318 28.9197 17.8376 29.1774 17.84C29.435 17.8423 29.6827 17.741 29.8649 17.5588L35.1449 12.2788Z" fill="white" />
        </g>
      </g>
      <defs>
        <filter id="filter0_dd_513_1553" x="16" y="0" width="28" height="29" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_513_1553" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_513_1553" result="effect2_dropShadow_513_1553" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_513_1553" result="shape" />
        </filter>
        <clipPath id="clip0_513_1553">
          <rect width="44" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ToggleSwitchYes;